import React from 'react'
import SubHeader from '../../layout/components/SubHeader'
import {toAbsoluteUrl} from '../../helpers/AssetHelpers'
import TabCard from './tabcards/TabCard'
function ClinicSettings() {
  return (
   <>
    <SubHeader title="Clinic Settings" description={"Clinic related settings."}/>
    <div className="row">
        <div className="col-3">
        <img src={toAbsoluteUrl('/media/illustrations/ecx/adjustments_re_gvct.svg')} className='img-fluid p-5' />
        </div>
        <div className="col-9">
           <TabCard/>
        </div>
    </div>
   </>
  )
}

export default ClinicSettings